/* eslint-disable */
// Here eslint disable is use to avoid line width error
import React from "react";

const UsersSlim = (props: { className?: string }) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
    <path
      d="M27.251,25.287H26.036V22.251A3.04,3.04,0,0,0,23,19.214V18a4.255,4.255,0,0,1,4.251,4.251Z"
      transform="translate(-9.034 -7.07)"
      fill="currentColor"
    />
    <path
      d="M14.145,25.287H12.93V22.251a3.04,3.04,0,0,0-3.036-3.036H6.251a3.04,3.04,0,0,0-3.036,3.036v3.036H2V22.251A4.256,4.256,0,0,1,6.251,18H9.894a4.256,4.256,0,0,1,4.251,4.251Z"
      transform="translate(-0.786 -7.07)"
      fill="currentColor"
    />
    <path
      d="M20,2V3.214a3.036,3.036,0,0,1,0,6.072V10.5A4.251,4.251,0,1,0,20,2Z"
      transform="translate(-7.855 -0.786)"
      fill="currentColor"
    />
    <path
      d="M9.251,3.214A3.036,3.036,0,1,1,6.214,6.251,3.036,3.036,0,0,1,9.251,3.214M9.251,2A4.251,4.251,0,1,0,13.5,6.251,4.251,4.251,0,0,0,9.251,2Z"
      transform="translate(-1.964 -0.786)"
      fill="currentColor"
    />
    <rect width="19" height="19" fill="none" />
  </svg>
);

export { UsersSlim };
